import React from 'react'
import { Box, Button } from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import { MicAIOn, Upload } from '@components/icons'

export const AINotetaker = ({
  setUploadModalOpen,
  openDocAutomationSessionLimitReachedModal,
  openDocAutomationPlanModal,
  documentationAutomationFreeTierSessionLimitReached,
  isAdmin
}) => {
  return (
    <Box
      p="32px"
      width="100%"
      borderRadius="8px"
      border="1px solid #E4E5E6"
      textAlign="center"
      mb="medium"
    >
      <Button
        id="pendo-sessions-start-session"
        as={Link}
        to="/start-session/select-client"
        width="100%"
        mb="xsmall"
      >
        <MicAIOn fill="white" height="16px" width="16px" />
        <Box width="8px" />
        Record session
      </Button>
      <Button
        onClick={() => {
          if (documentationAutomationFreeTierSessionLimitReached) {
            if (isAdmin) {
              openDocAutomationPlanModal()
            } else {
              openDocAutomationSessionLimitReachedModal()
            }
          } else {
            setUploadModalOpen(true)
          }
        }}
        variant="outline"
        width="100%"
        id="pendo-upload-session"
      >
        <Upload fill="black" width="16" />
        <Box width="8px" />
        Upload recording
      </Button>
    </Box>
  )
}
